import { pathOr } from 'ramda'
import React from 'react'
import { useSelector } from 'react-redux'

import { noop } from '@/app/definitions'
import { OrgReportFilter } from '@/app/module/reports/types'
import { selectUserTimezone } from '@/app/module/user/store/selectors'
import { selectCountriesTimezones, selectDefaultCountryCode } from '@/app/module/utils/store/selectors'

import SpendReportFilter from './spend-report-filter'

type Props = {
  filter: OrgReportFilter
}

const ReportFileFilterContainer: React.FC<Props> = ({ filter }) => {
  const countriesTimezones = useSelector(selectCountriesTimezones)
  const countryCode = useSelector(selectDefaultCountryCode)
  const timezone = useSelector(selectUserTimezone)
  const timezones = useSelector(pathOr({}, ['utils', 'countriesTimezonesList', 'data']))

  return (
    <SpendReportFilter
      campaignOptions={[]}
      campaignsLoading={false}
      countriesTimezones={countriesTimezones}
      countryCode={countryCode}
      disabled
      filter={filter}
      timezone={timezone}
      timezones={timezones}
      onCampaignsSearch={noop}
    />
  )
}

export default ReportFileFilterContainer
